import VueLoader from '../../default/vue-loader'
import TermsAndConditions from './terms-and-conditions'

document.addEventListener('turbolinks:load', () => {
  VueLoader.loadVueComponent(TermsAndConditions,
    document.getElementById('TermsAndConditions'))
})
